<div class="background">
    <div class="cookies">
        <p>Utilizamos cookies propias y de terceros con fines analíticos y para mejorar nuestros servicios. Puedes cambiar la configuración u obtener más información <span (click)="goToCookies()">aquí</span>.</p>
        <button class="main-light-button" (click)="setCookies()">Aceptar</button>
    </div>
</div>
